// extracted by mini-css-extract-plugin
export var resizer = "_ei-0";